import React, {PureComponent, useEffect, useRef, useState} from 'react';
import { useAuthContext } from '../../../contexts/AuthContext';
import { CreateAgendaRequestByComIdMutation, CreateAgendaRequestByComIdMutationVariables, CreateAgendaRequestMutation, CreateAgendaRequestMutationVariables, GetAgendaRequestQuery, GetAgendaRequestQueryVariables, GetAgendaShiftQuery, GetAgendaShiftQueryVariables, GetAgendaUserQuery, GetAgendaUserQueryVariables, ModelSortDirection, ShiftsByComIdQuery, ShiftsByComIdQueryVariables, ShiftsByUserQuery, ShiftsByUserQueryVariables, UpdateAgendaRequestMutation, UpdateAgendaRequestMutationVariables, UpdateAgendaShiftMutation, UpdateAgendaShiftMutationVariables, UsersByComIdQuery, UsersByComIdQueryVariables } from '../../../graphql/API';
import { getAgendaShift, getAgendaUser, getAgendaRequest, updateAgendaRequest, updateAgendaShift, createAgendaRequest, usersByComId, createAgendaRequestByComId } from '../queries';
import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { Button, Col, Form, InputGroup, Modal, Row, Spinner, Stack } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { IoArrowRedoCircleOutline } from 'react-icons/io5';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { enUS, fr } from 'date-fns/locale';
import Cookies from 'js-cookie';
import CustomModal from '../../../components/Modals/CustomModal';
import UserImage from '../../../components/UserImage';
import { MdSwapHorizontalCircle } from "react-icons/md";
import Sidebar from '../../services/Sidebar/Sidebar';
import { v4 as uuidv4 } from 'uuid';
import Select from 'react-dropdown-select';
import { useForm } from 'react-hook-form';
import TopicNotificationService from '../../services/TopicService';
import { ALLUSERS_PER_PAGE } from '../../../config';

type RequestData = {
  userInfo: string;
};


const CreateRequestSwapScreen = () => {
  // AUTH
  const {userId: AuthUserId} = useAuthContext();
  // I18N
  const { t } = useTranslation();
  const savedLang = Cookies.get('language');
  // PARAMS
  const { id } = useParams<{ id: string }>();
  // NAVIGATION
  const navigate = useNavigate();
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [footerModal, setFooterModal] = useState(true);
  // NOTIFICATION
  const {sendTopicNotification} = TopicNotificationService();
  // FORM
  const {register, control, handleSubmit, watch, reset} = useForm<RequestData>();


  const {data: dataUser, loading: loadingUser, error: errorUser, refetch: refetchUser, fetchMore: fetchMoreUser} = useQuery
    <GetAgendaUserQuery, GetAgendaUserQueryVariables>(getAgendaUser,
      {variables: {userId: AuthUserId}});

  const {data: dataShift, loading: loadingShift, error: errorShift, refetch: refetchShift, fetchMore: fetchMoreShift} = useQuery
      <GetAgendaShiftQuery, GetAgendaShiftQueryVariables>(getAgendaShift, 
        {variables: {shiftId: id,
      }});

  const [fetchDataUsers, {data: dataUsers, loading: loadingUsers, error: errorUsers, 
        refetch: refetchUsers, fetchMore: fetchMoreUsers}] = useLazyQuery
        <UsersByComIdQuery, UsersByComIdQueryVariables>(usersByComId);
    
  const [doCreateRequest] = useMutation<CreateAgendaRequestByComIdMutation, CreateAgendaRequestByComIdMutationVariables>(createAgendaRequestByComId);
  // const [doCreateRequest] = useMutation<CreateAgendaRequestMutation, CreateAgendaRequestMutationVariables>(createAgendaRequest);

  const user = dataUser?.getAgendaUser;
  const shift = dataShift?.getAgendaShift;

  useEffect(() => {
    document.title = t('title.shift');
  }, []);

  useEffect(() => {
    if (!user) return;
    if (!user.comId) return;
    fetchDataUsers({variables: {comId: user.comId, limit: ALLUSERS_PER_PAGE, sortDirection: ModelSortDirection.ASC}});
  }, [user]);

  const users = dataUsers?.usersByComId?.items || [];
  
  const generateCustomId = () => {
    const prefix = "Request";
    const uniquePart = uuidv4();
    return `${prefix}-${uniquePart}`;
  };

  // console.log(dataShifts?.shiftsByUser);
  if (!user || !shift || !users) {
    return (
        <div className="spinnerContainer">
            {/* <Spinner animation="border" role="status" style={styles.spinner as React.CSSProperties}> */}
            <Spinner animation="border" role="status" className="spinner">
                <span className="visually-hidden">Loading...</span>
            </Spinner>   
        </div>
    )
  };

  const getLanguage = () => {
    switch (savedLang) {
      case 'en':
        return enUS
      case 'fr':
        return fr
      default:
        return enUS
    }
  }

  const createRequest = async ({userInfo}: RequestData) => {
    setShowCustomModal(false);
    try {
      const userData = userInfo.split("!!!#%#!!!");
      const suggestedUser = userData[0];
      const suggestedUserUsername = userData[1];
      const suggestedUserImage = userData[2];
      const date = new Date();
      const now = date.toISOString();
      const requestId = generateCustomId();
      await doCreateRequest({
        variables: {
          // input: {
            requestId: requestId,
            userId: shift.userId,
            shiftId: shift.shiftId,
            comId: user.comId,
            description: "",
            type: "swap",
            suggestedUser,
            suggestedUserUsername,
            suggestedUserImage,
            startAt: now, // Needed to search
            stopAt: now,  // Needed to search
            accepted: false,
            confirmed: false,
            completed: false,
            deleted: false,
            updatedAt: now,
            createdAt: now,
          // }
        }
      });
      // await sendRequestNotification(shift.role, shift.location ?? undefined, suggestedUser.FCMtoken ?? undefined, shift.userId ?? undefined, shift.shiftId, shift.startAt, shift.stopAt, true);
      await sendTopicNotification(
        suggestedUserUsername,                                      // title
        t('request.swapLink'),                                      // body
        undefined,                                                  // FCMtoken
        suggestedUser ?? undefined,                                 // receiverId
        requestId,                                                  // dataID
        now,                                                        // startAt
        now,                                                        // stopAt
        "swapRequest");                                             // type
      for (const usr of users) {
        if (usr.type === "MANAGER") {
          if (usr.userId !== AuthUserId) {
            if (usr?.userId !== suggestedUser) {
              await sendTopicNotification(
                suggestedUserUsername,
                t('request.swapLink'),
                undefined, 
                suggestedUser,
                requestId, 
                now,
                now,
                "swapRequest");
            }                                    
          }
        } 
      }
      
      { user.type === 'MANAGER' ?
        navigate(t('link.requests_swap'), { state: { status: "bg-success", title: "", toastMessage: t('toast.swapCreated') }})
      :
        navigate(t('link.requests_swap'), { state: { status: "bg-success", title: "", toastMessage: t('toast.swapCreated') }})
      }
    } catch(error) {
        alert("Error on Shift Acceptation: " + error);
    };
  };

  const swapShift = ({userInfo}: RequestData) => {
    // navigate('/requests/swap/shift/' + id);
    if (userInfo) {
      const username = userInfo.split("!!!#%#!!!")[1];
      setFooterModal(false);
      setContentModal(<>
        <Modal.Header closeButton>
          <Modal.Title>{t('shift.areYouSure')}</Modal.Title>
            </Modal.Header>
      
            <Modal.Body>
              <p>{t('request.swapMessage')}{username} ?</p></Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowCustomModal(false)}>
                {t('shift.cancel')}
              </Button>
              <Button variant="primary" onClick={() => handleSubmit(createRequest)()}>
                {t('request.transfer')}
              </Button>
            </Modal.Footer>
        </>);
      setShowCustomModal(true);
    } else {
      setContentModal(<>
        <Modal.Header closeButton>
          <Modal.Title>{t('request.request_error')}</Modal.Title>
            </Modal.Header>
      
            <Modal.Body>
              <p>{t('error.users_required')}</p>
            </Modal.Body>
        </>);
      setShowCustomModal(true);
    }
  } 

//   shifts.filter((item) => item?.shiftId !== shift.shiftId).slice(0, 4).map((job, index) => {
//     console.log(job);
// });

  
  return (
    <>
    <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        isFooter={footerModal}
        // animation={true}
      />
      <div className="d-flex">
        <Sidebar user={user} />
        <div className="users-container flex-grow-1 p-3">
          <Stack direction="vertical" gap={3} className="w-100 mt-3 p-3" style={{border: '1px solid #DDD', borderRadius: 10, backgroundColor: '#f5f5f5'}}>
            <Form className="register-form">
              <h2 className="text-center">{t('request.transferSwapTitleForm')}</h2>
              <InputGroup>
                <Form.Label htmlFor="userSelect">{t('request.transferTo')}</Form.Label>
              </InputGroup>
              <InputGroup>
                <Form.Select
                    aria-label={t('request.transferTo')}
                    className="d-inline me-lg-2"
                    {...register("userInfo")} 
                    name="userInfo"
                  >
                    <option value="">{t('shift.select')}</option>
                    { users.map((user) => 
                      <option value={`${user.userId}!!!#%#!!!${user.username}!!!#%#!!!${user.image}`}>{user.username}</option>
                    )}
                </Form.Select>
              </InputGroup>
              <InputGroup>
                <Button type="submit" onClick={handleSubmit(swapShift)} disabled={loadingUsers}>{loadingUsers ? t('signup.loading') : t('request.submitRequest')}</Button>
              </InputGroup>
            </Form>
          </Stack>
        </div>
      </div>
    </>
  );
};

export default CreateRequestSwapScreen;


